<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Account</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Change Password</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Create a new your password for your account.
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="field">
                        <label for="password1">New Password</label>
                        <InputText id="password1" type="password" v-model.trim="updatePasswordInfo.password1"/>
                    </div>

                    <div class="field">
                        <label for="password2">Verify Password</label>
                        <InputText id="password2" type="password" v-model.trim="updatePasswordInfo.password2"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updatePassword"></Button>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import CompanyService from "@/service/CompanyService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            profile: {},
            submitted: false,
            updatePasswordInfo: {}
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        async updatePassword() {
            this.submitted = true;

            console.log("[ConfigurationPassword][updatePassword] this.updatePasswordInfo = [].", this.updatePasswordInfo)

            if (this.updatePasswordInfo.password1.trim()) {
                if (this.updatePasswordInfo.password1.length < 8) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Unsuccesful',
                        detail: 'Password needs to be at least 8 characters',
                        life: 3000
                    });
                } else if (this.updatePasswordInfo.password1 !== this.updatePasswordInfo.password2) {
                    this.$toast.add({severity: 'error', summary: 'Unsuccesful', detail: 'Passwords do not match', life: 3000});
                } else if (this.updatePasswordInfo.password1 === this.updatePasswordInfo.password2) {
                    this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Passwords do match', life: 3000});

                    try {
                        var newUserDto = {
                            id: this.userStore.user.id,
                            password: this.updatePasswordInfo.password1,
                            username: this.profile.username,
                            email: this.profile.email,
                            mobile: this.profile.mobile,
                            firstName: this.profile.firstName,
                            lastName: this.profile.lastName,
                            roles: this.profile.roles,
                            companyId: this.profile.companyId
                        };
                        const response = await UserService.updateUser(this.userStore.user.id, newUserDto);
                        console.log("[ConfigurationPassword][updatePassword] Password updated. Response = [].", response)

                        const userData = await UserService.getUser(this.userStore.user.id);
                        this.profile = userData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Updated user password',
                            life: 3000
                        });
                    } catch (e) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to update user password. Please try again.',
                            life: 3000
                        });

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }
                }
            }

            this.updatePasswordInfo = {};
            this.submitted = false;
        }

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
